module.exports = __webpack_public_path__ + "img/slidebar-bg.c487d618.png";